// extracted by mini-css-extract-plugin
export default {"filterContainer":"FailSearch_filterContainer__LD68j"};